<h1 [translateParams]="{ name: context.data.name }"
    translate
    matDialogTitle>
    environment_robots_modal_title
</h1>
<mat-dialog-content>
    <ui-environment-robots-grid #environmentRobotsGrid
                                [environmentId]="context.data.id"
                                (close)="closeModal()">
    </ui-environment-robots-grid>
</mat-dialog-content>

<mat-dialog-actions *ngLet="{
                        environmentGridLoading: environmentRobotsGrid.loading$ | async
                    } as state"
                    align="end">
    <button mat-dialog-close
            mat-button
            type="button"
            data-cy="environment-robots-cancel">
        {{ 'modal_action_cancel' | translate }}
    </button>
    <button [uiAuthorizeDisable]="'Environments.Edit'"
            [spinnerButtonLoading]="state.environmentGridLoading"
            [disableIf]="state.environmentGridLoading"
            (click)="environmentRobotsGrid.updateEnvironment()"
            ui-spinner-button
            mat-flat-button
            type="button"
            color="primary"
            data-cy="environment-robots-submit">
        {{ 'modal_action_update' | translate }}
    </button>
</mat-dialog-actions>
